// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M20 2H4V4H5V8H2V22H8.5V15H15.5V22H22V8H19V4H20V2ZM13 7H15V9H13V11H11V9H9V7H11V5H13V7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.5 22V17H13.5V22H10.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-hospital-filled')
export default class HospitalFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hospital-filled',
    }
  }
}
